import React, { Component } from 'react'
import { Tooltip } from 'antd'
import Col from 'react-bootstrap/Col'
import '../../wallet.css'
import './transferir.css'
import { Row } from 'react-bootstrap'
import { Select, Input, Form } from 'antd'
import { connect } from 'react-redux'
import { getCashOut } from '../../../../redux-flow/actions/wallet_brl'
import { infoRequired, validateCpf, validateAgencia, validateCnpj, validateCpfCnpj } from '../../../../utils/validators'
import bancos from '../../../Contratos/FormContrato/bancos'
import { maskCnpjOnChange as maskCnpj, maskCpfOnChange as maskCpf } from '../../../../utils/masks'
import moment from 'moment-timezone'

const Option = Select.Option

const mapStateToProps = state => ({
    userid: state.login.userid,
    cashSubmit: state.wallet_brl.cashSubmit,
    cashSuccess: state.wallet_brl.cashSuccess,
    cashOutMessage: state.wallet_brl.cashOutMessage,
    cashOutError: state.wallet_brl.cashOutError
})

const mapDispatchToProps = dispatch => ({
    handleSubmit: (value, tabAtiva, form, userid) => e => {
        e.preventDefault()
        dispatch(getCashOut(value, tabAtiva, form, userid))
    }
})

const CashOutForm = Form.create({ name: 'cash-out' })(
    connect(mapStateToProps, mapDispatchToProps)(
    ({ handleSubmit, value, form, tabAtiva, open, onClick, cashSubmit, userid, cashSuccess, cashOutError, cashOutMessage, balance }) => (
            <Form
                onSubmit={handleSubmit(value, tabAtiva, form, userid)}
            >
                <Row >
                    <Col md={6} className='d-flex flex-column'>
                        <label className='titulosTransferir mb-2 pr-3'>Tipo de Conta</label> 
                        <Form.Item>
                            {form.getFieldDecorator('accountType', {
                                rules: [ infoRequired ]
                            })(
                                <Select className="inputTransferir" disabled={cashSubmit}>
                                    <Option value='CHECKING_ACCOUNT'>Corrente</Option>
                                    <Option value='SAVINGS_ACCOUNT'>Poupança</Option>
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    <Col md={6} className='d-flex flex-column pl-3'>
                        <label className='titulosTransferir mb-2'>CPF / CNPJ</label>
                        <Form.Item>
                            {form.getFieldDecorator('document', {
                                rules: [ infoRequired, validateCpfCnpj() ],
                                
                            })(
                                <Input disabled={cashSubmit} type='text' className='inputTransferir' onChange={(e) => (e.target.value).length <= 14 ? maskCpf(e) : maskCnpj(e)} onKeyPress={(e) => (e.target.value).length <= 14 ? maskCpf(e) : maskCnpj(e)} />
                            )}
                        </Form.Item>
                    </Col>
                </Row>             
                <Row className='mt-4'>
                    <Col md={12} className='d-flex flex-column'>
                        <label className='titulosTransferir mb-2'>Nome</label>
                        <Form.Item>
                            {form.getFieldDecorator('name', {
                                rules: [ infoRequired ]
                            })(
                                <Input disabled={cashSubmit} style={{ width: '100%' }} type='text' className='inputTransferir'/>
                            )}
                        </Form.Item>
                    </Col>
                </Row>

                <Row className='mt-4 mb-4'>
                    <Col>
                    <hr className='linhaHorizontal'/>
                    </Col>
                </Row>
                <Row >
                    <Col md={12} className='d-flex flex-column'>
                        <label className='titulosTransferir mb-2 pr-3'>Nome do Banco</label>
                        <Form.Item >
                            {form.getFieldDecorator('bankCode', {
                                    rules: [ infoRequired ]
                            })(
                                <Select disabled={cashSubmit}
                                    showSearch
                                    className="inputTransferir"
                                    style={{ width: '100%' }}
                                >
                                    {bancos.map(banco =>(
                                        <Option value={banco.name}>{banco.name}</Option>
                                    ))}
                                </Select>
                            )}
                        </Form.Item>
                    </Col>

                    {/* <Col md={6} className='p-0 pl-3'>
                        <label className='titulosTransferir mb-2 pr-3'>Salvar como favorito?</label> 
                        <div className='d-flex'>
                            <Col md={3} className='p-0 mr-1'>
                                <div id='salvar' className={`tabFav ${tabAtiva == 'salvar' ? 'tabFavActive' : ''}`} onClick={() => onClick('salvar')}>
                                    <label className='nomeTabTransf'>Sim</label>
                                </div> 
                            </Col>

                            <Col md={3} className='p-0 ml-1'>
                                <div id='naoSalvar' className={`tabFav ${tabAtiva == 'naoSalvar' ? 'tabFavActive' : ''}`} onClick={() => onClick('naoSalvar')}>
                                    <label className='nomeTabTransf'>Não</label>
                                </div> 
                            </Col>                                  
                        </div>
                    </Col> */}
                </Row>   

                <Row className='mt-4'>
                    <Col md={6} className='d-flex flex-column pl-3'>
                        <label className='titulosTransferir mb-2'>Agência</label> 
                        <Form.Item>
                            {form.getFieldDecorator('branch', {
                                    rules: [ infoRequired, validateAgencia() ]
                                })(
                                <Input disabled={cashSubmit} type='text' className='inputTransferir'/>
                            )}
                        </Form.Item>
                        {!cashSuccess && cashOutError === 'branch' ? <small style={{color: 'red'}}>Número de agência inválido</small> : ''}
                    </Col>

                    <Col md={6} className='d-flex flex-column pl-3'>
                        <label className='titulosTransferir mb-2'>Conta (com dígito)</label> 
                        <Form.Item>
                            {form.getFieldDecorator('account', {
                                    rules: [ infoRequired ]
                                })(
                                <Input disabled={cashSubmit} type='text' className='inputTransferir'/>
                            )}
                        </Form.Item>
                        {!cashSuccess && cashOutError === 'account' ? <small style={{color: 'red'}}>Número de conta inválido</small> : ''}
                    </Col>
                    <Col md={12} className='d-flex flex-column pl-3 mt-4'>
                        <label className='titulosTransferir mb-2'>Confirme sua senha</label> 
                        <Form.Item>
                            {form.getFieldDecorator('password', {
                                    rules: [ infoRequired ]
                                })(
                                <Input disabled={cashSubmit} type='password' className='inputTransferir'/>
                            )}
                        </Form.Item>
                        {!cashSuccess && cashOutMessage === 'Senha incorreta' ? <small style={{color: 'red'}}>Senha incorreta</small> : ''}
                    </Col>
                </Row>
                {!open ? (
                    <Row>
                        <Col md={12}>
                            <div className="d-flex mt-5 flex-column justify-content-center align-items-center saldoWrapper">
                                <label className="tx-gray mb-0">Transferência indisponível</label>
                                <label className="tx-pink mb-0">Horário permitido: Seg-Sex | 09h05 - 15h55</label>
                            </div>
                        </Col>
                    </Row>) : (
                        <Row>
                            <Col md={12}>
                            { cashSubmit ? 
                                <div className="mt-5">
                                    <h4 className="tx-pink">Realizando transferência...</h4>
                                </div> 
                            :   <div className="mt-5">
                                    {balance/100 >= value/100 ?
                                        <button type='submit' className="btnSubmit">Enviar</button>
                                    :
                                        <label style={{color: "red"}}>Saldo insuficiente</label>
                                    }
                                </div> }
                        </Col>
                        </Row>
                    )
                }
                {/* <Row>
                    {moment(now).isAfter(limit) || moment(now).isBefore(from) ? 
                        <Col md={12}>
                            <div className="d-flex flex-column justify-content-center align-items-center saldoWrapper">
                                <label className="tx-gray mb-0">Transferência indisponível</label>
                                <label className="tx-pink mb-0">Horário permitido: 09h05 - 15h55</label>
                            </div>
                        </Col> :
                        <Col md={12}>
                            { cashSubmit ? 
                                <div className="mt-5">
                                    <h4 className="tx-pink">Realizando transferência...</h4>
                                </div> 
                            :   <div className="mt-5">
                                    {balance/100 >= value/100 ?
                                        <button type='submit' className="btnSubmit">Enviar</button>
                                    :
                                        <label style={{color: "red"}}>Saldo insuficiente</label>
                                    }
                                </div> }
                        </Col>
                    }
                </Row> */}
            </Form>
        )
    )
)

class NovoFavorecido extends Component {
    constructor(props) {
    super(props)
    this.state = {
        tabAtiva: 'salvar',
        open: false
                    // fillBackground: false,
    }}

    onClickTab = (id) => {
        if(this.state.tabAtiva != id){
            this.setState({tabAtiva:id})
        }
    }

    componentDidMount() {
        const limit = moment().format("YYYY-MM-DD 15:55:00")
        const now = moment().tz('America/Sao_Paulo').format("YYYY-MM-DD HH:mm:ss")
        const from = moment().format("YYYY-MM-DD 09:05:00")
        const day = moment().tz('America/Sao_Paulo').isoWeekday()

        if(moment(now).isBefore(from) || moment(now).isAfter(limit) || day === 6 || day === 7) {
            this.setState({ open: false })
        } else {
            this.setState({ open: true })
        }
    }


        render() {
            return (
    
                <>
                    <CashOutForm open={this.state.open} balance={this.props.balance} value={this.props.value} onClick={this.onClickTab} tabAtiva={this.state.tabAtiva} />
                
                </>
            )
        }
    }

export default NovoFavorecido